import {BaseModel} from '../../base/models/base-model.model';

export class FilterModel extends BaseModel {

  private _type?: string;

  private _subtype?: string;

  private _label?: string;

  private _dtoField?: string;

  private _value?: any;

  private _disabled?: boolean;

  private _options?: Array<any>;

  private _pattern?: string;

  private _locked?: boolean;

  constructor(type?: string, label?: string, dtoField?: string, value?: any, disabled?: boolean, options?: Array<any>, pattern?: string, subtype?: string, locked?: boolean) {
    super();
    this._type = type;
    this._subtype = subtype;
    this._label = label;
    this._dtoField = dtoField;
    this._value = value;
    this._disabled = disabled;
    this._options = options;
    this._pattern = pattern;
    this._locked = locked;
  }

  get locked(): boolean {
    return this._locked;
  }

  set locked(value: boolean) {
    this._locked = value;
  }

  get subtype(): string {
    return this._subtype;
  }

  set subtype(value: string) {
    this._subtype = value;
  }

  get pattern(): string {
    return this._pattern;
  }

  set pattern(value: string) {
    this._pattern = value;
  }

  get value(): any {
    return this._value;
  }

  get options(): Array<any> {
    return this._options;
  }

  set options(value: Array<any>) {
    this._options = value;
  }

  set value(value: any) {
    this._value = value;
  }

  get type(): string {
    return this._type;
  }

  set type(value: string) {
    this._type = value;
  }

  get label(): string {
    return this._label;
  }

  set label(value: string) {
    this._label = value;
  }

  get dtoField(): string {
    return this._dtoField;
  }

  set dtoField(value: string) {
    this._dtoField = value;
  }

  get disabled(): boolean {
    return this._disabled;
  }

  set disabled(value: boolean) {
    this._disabled = value;
  }
}
